<template>
  <div class="assistant-card skeleton-card">
    <div class="card-content d-flex">
      <div class="card-info p-1">
        <b-skeleton type="avatar" size="48px" class="mr-3"></b-skeleton>
        <div class="info-content">
          <div class="title-row">
            <b-skeleton width="60%" height="16px" class="mb-1"></b-skeleton>
          </div>
          <b-skeleton width="80%" height="12px" class="mb-1"></b-skeleton>
          <b-skeleton width="70%" height="12px"></b-skeleton>
        </div>
      </div>
      <div class="card-actions">
        <b-skeleton type="button" width="40px" height="100%"></b-skeleton>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BSkeleton,
} from 'bootstrap-vue'

export default {
  name: 'AssistantCardSkeleton',
  components: {
    BSkeleton,
  }
}
</script>

<style lang="scss" scoped>
.assistant-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  transition: all 0.2s ease-in-out;
  
  &.skeleton-card {
    cursor: default;
    background-color: #f8f9fa;
  }
}

.card-content {
  height: 100%;
}

.card-info {
  display: flex;
  flex: 1;
  margin-right: 0.75rem;
}

.info-content {
  flex: 1;
  min-width: 0;
}

.title-row {
  display: flex;
  align-items: center;
  margin-bottom: 0.25rem;
}

.card-actions {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
}

// Skeleton animation
.skeleton-card {
  .b-skeleton {
    animation: skeleton-loading 1.5s ease-in-out infinite alternate;
  }
}

@keyframes skeleton-loading {
  0% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}
</style>